import React, { useMemo } from 'react';
import { Card, Table, Typography } from 'antd';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import LayoutPublic from './LayoutPublic';
import { getAllCampaignStats } from '../utils/clickTracker';
import { campaignsConfig } from '../config/campaignsConfig';

const { Title } = Typography;

function Dashboard() {
  const stats = getAllCampaignStats();

  // Converte stats em array para tabela e gráfico
  const tableData = [];
  const chartDataMap = {};

  Object.keys(stats).forEach((campaignId) => {
    const clicksByDate = stats[campaignId];
    const campaign = campaignsConfig[campaignId];
    const name = campaign ? campaign.name : campaignId;

    Object.keys(clicksByDate).forEach((date) => {
      const clicks = clicksByDate[date];
      tableData.push({
        key: `${campaignId}-${date}`,
        campaign: name,
        date,
        clicks,
      });

      if (!chartDataMap[date]) {
        chartDataMap[date] = { date };
      }
      chartDataMap[date][name] = clicks;
    });
  });

  const chartData = useMemo(
    () => Object.values(chartDataMap).sort((a, b) => (a.date > b.date ? 1 : -1)),
    [chartDataMap]
  );

  const columns = [
    { title: 'Campanha', dataIndex: 'campaign', key: 'campaign' },
    { title: 'Data', dataIndex: 'date', key: 'date' },
    { title: 'Cliques', dataIndex: 'clicks', key: 'clicks' },
  ];

  const campaignNames = Object.values(campaignsConfig).map((c) => c.name);

  return (
    <LayoutPublic>
      <Title level={2} style={{ marginBottom: 24 }}>
        Dashboard de Cliques
      </Title>

      <Card style={{ marginBottom: 24 }}>
        <Title level={4}>Evolução diária de cliques</Title>
        <div style={{ width: '100%', height: 300 }}>
          <ResponsiveContainer>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              {campaignNames.map((name) => (
                <Line
                  key={name}
                  type="monotone"
                  dataKey={name}
                  dot={false}
                />
              ))}
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card>
        <Title level={4}>Tabela de cliques por dia</Title>
        <Table columns={columns} dataSource={tableData} pagination={false} />
      </Card>
    </LayoutPublic>
  );
}

export default Dashboard;
